import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterLink } from '@angular/router';

import { IQObservation } from 'src/app/models/iq-observation.model';

@Component({
  selector: 'app-ons-widget-observations',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [DatePipe, RouterLink, MatProgressBarModule],
  template: `
    <div
      class="relative flex h-full flex-col overflow-hidden rounded-2xl bg-white p-10"
    >
      @if (isLoading()) {
        <div
          class="pointer-events-none absolute left-0 top-0 h-full w-full bg-white/80"
        >
          <mat-progress-bar mode="indeterminate" />
        </div>
      }
      <div class="mb-2 font-montserrat text-2xl font-semibold">
        IQ Observations
      </div>
      <p class="mb-8 text-xs italic text-gray-400">
        (This output is generated using AI and may contain inaccuracies; please
        verify with source data before taking actions)
      </p>
      <div
        class="max-h-[260px] flex-1 overflow-y-auto pr-2 text-base font-normal leading-relaxed"
      >
        @if (observations()?.length) {
          @for (obs of observations(); track obs) {
            <div class="p-4 odd:bg-gray-50">
              <div class="mb-1 flex justify-between text-xs font-semibold">
                {{ obs.date + ' ' + obs.beginTime | date: 'short' }}
              </div>
              <div class="whitespace-pre-line text-sm">
                {{ obs.summary }}
                @if (obs.caseLink) {
                  Case
                  <a class="font-semibold" [routerLink]="obs.caseLink.url">
                    {{ obs.caseLink.label }}
                  </a>
                  has been opened to track progress.
                }
              </div>
            </div>
          }
        } @else {
          <div class="pb-4">
            No network performance degradation detected by the IQ analytics
            engine.
          </div>
        }
      </div>
    </div>
  `,
})
export class WidgetObservationsComponent {
  readonly observations = input<IQObservation[]>([]);

  readonly isLoading = input<boolean>(false);
}
